/* eslint-disable no-underscore-dangle,global-require */

import {
  ApolloClient,
  ApolloLink,
  type DefaultOptions,
  HttpLink,
  InMemoryCache,
} from '@apollo/client';
import { canUseDOM } from 'exenv';
import { URLs } from 'api/urls';

const getGraphqlUrl = () =>
  process.env.NODE_ENV === 'test' || !canUseDOM
    ? [URLs.SERVER_URI, URLs.GRAPHQL_URL].join('')
    : URLs.GRAPHQL_URL;

const link = ApolloLink.from([
  new HttpLink({
    uri: getGraphqlUrl(),
    // MSW 2.x in Node 24 has AbortSignal compatibility issues
    // Remove signal in test environment to avoid "Expected signal to be an instance of AbortSignal" error
    fetch:
      process.env.NODE_ENV === 'test'
        ? (uri, options) => {
            const { signal, ...restOptions } = options || {};
            return fetch(uri, restOptions);
          }
        : undefined,
  }),
]);

let apolloClient: ApolloClient<any>;

export const getApolloClient = () => {
  if (apolloClient) {
    return apolloClient;
  }

  const APOLLO_DEFAULT_OPTIONS: DefaultOptions = {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  };

  apolloClient = new ApolloClient({
    cache: new InMemoryCache().restore({}),
    link,
    defaultOptions: APOLLO_DEFAULT_OPTIONS,
  });

  return apolloClient;
};
